module.exports = __webpack_public_path__ + "593a3d53/img/saly-icon.39e12342.jpg";